<!-- eslint-disable prettier/prettier -->

<!-- 393: rekryteringslots dalarna. 
     390: Applicationportal Sweden-->
<template>
  <div
    v-if="
      props.company.Container.DTO.id === 390 ||
      props.company.Container.DTO.id === 393
    "
  >
    <CustomerGdpRrekryteringslots :company="props.company" />
  </div>
  <div
    v-else-if="
      props.company.Container.DTO.id !== 390 ||
      props.company.Container.DTO.id !== 393
    "
  >
    <CustomerGdprDefault :company="props.company" />
  </div>
  <!-- Rekryteringsbyrå: extra mottagarklausul per annons (ANSKNI-100).
       Visas när annonsen lämnas ut till ett namngivet kundföretag. -->
  <CustomerGdprAgencyRecipient
    v-if="props.recipientCompany"
    :company="props.company"
    :recipient-company="props.recipientCompany"
  />
</template>
<script setup lang="ts">
import { Profile } from "@/models/Profile";
import { defineProps } from "vue";
import CustomerGdprDefault from "./CustomerGdprDefault.vue";
import CustomerGdpRrekryteringslots from "./CustomerGdpRrekryteringslots.vue";
import CustomerGdprAgencyRecipient from "./CustomerGdprAgencyRecipient.vue";

const props = defineProps({
  company: {
    type: Profile,
    required: true,
  },
  // Namn på mottagande kundföretag för den aktuella annonsen. Tom => ingen
  // mottagarklausul. Kommer från positionens metadata via InputCheckbox2.
  recipientCompany: {
    type: String,
    required: false,
    default: "",
  },
});
</script>
